<h2
  class="text-[#21252A] font-roboto !text-[1.125rem] !font-semibold !leading-[1.35rem] !tracking-[-0.03375rem]"
>
  Technical Evaluation
</h2>
<table class="w-full border-collapse border">
  <thead>
    <tr class="bg-[#D9D9D9]">
      <th class="border py-2 pl-[2.5rem] text-left w-[40vw]">Criteria</th>
      <th class="border py-2 pl-[1.5rem] text-left w-[20vw]">Score</th>
      <th class="border py-2 pl-[2rem] text-left w-[40vw]">Key Indicators</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of evaluationCriteria" class="h-[5.8rem]">
      <td class="border-x">
        <div class="flex gap-1 !mb-[2.5rem] ml-[1.13rem]">
          <img [src]="item.iconClass" alt="Icon" *ngIf="item.iconClass" />
          {{ item.criteria }}
        </div>
      </td>

      <td class="border-x px-[1.76rem]">
        <mat-form-field
          appearance="outline"
          class="!h-[50px] custom-placeholder !w-[100%]"
        >
          <mat-select
            [placeholder]="'Select Score'"
            [value]="item?.score"
            (selectionChange)="changeValue(item, $event)"
          >
            <mat-option
              *ngFor="let option of evaluationCriteriaOptions"
              [value]="option?.value"
              class="hover:!bg-[#fae8e1] border-t"
            >
              {{ option?.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </td>

      <td class="border-x">
        <p [innerHTML]="item?.score ? keyIndicators[item?.score].description : keyIndicators[0].description" class="pl-[5px]"></p>
        <!-- <mat-form-field appearance="outline" class="w-[100%] px-[2.2rem]">
          <textarea
            matInput
            placeholder="Enter comments"
            [(ngModel)]="item.comments"
            rows="2"
          ></textarea>
        </mat-form-field> -->
      </td>
    </tr>
  </tbody>
</table>

<div class="mt-6 text-left flex justify-between">
  <p
    class="bg-[#F1F3F5] text-[#E76B3F] !h-[48px] !pt-[10px] px-4 py-2 rounded mr-4 border-[1px] border-[#E76B3F]"
  >
    Calculated Score {{ calculatedResult ? calculatedResult : "--" }}
  </p>

  <div class="flex">
    <div class="flex">
      <button
        class="bg-[#F1F3F5] text-[#E76B3F] px-4 !h-[48px] rounded mr-4 border-[1px] border-[#E76B3F]"
        (click)="calculateResult()"
      >
        Calculate Score
      </button>
    </div>
    <button
      class="bg-[#E76B3F] text-[#F1F3F5] px-[1.5rem] !h-[48px] rounded"
      (click)="submitForm()"
    >
      Submit
    </button>
  </div>
</div>
